import { useCallback, useMemo } from 'react'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { useRouter } from 'next/router'
import { EDataKeys } from '@ucheba/utils/types/dataKeys'

/** Хук для использования компонента сортировки */
interface IUseSortButtonCore {
  (
    sortItems: {
      key: string // ключ
      direction: string // направление - по возрастанию (asc) или по убыванию (desc)
      name: string // лабел элемента который виден пользователю
    }[]
  ): {
    activeIndex: number
    onClick: (_: number, key: string, direction: string) => void
  }
}

export const useSortButtonCore: IUseSortButtonCore = (sortItems) => {
  const router = useRouter()
  const { query } = router

  // получаем массив ключей сортировки
  const keys = useMemo(() => {
    return sortItems.map((item) => item.key)
  }, [sortItems])

  // получаем индекс активного элемента массива элементов для сортировки
  const activeIndex = useMemo(() => {
    const key = sortItems.findIndex((item) => {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (query[EDataKeys.orderBy] && query[EDataKeys.orderDirection]) {
        if (
          item.key === query[EDataKeys.orderBy] &&
          item.direction === query[EDataKeys.orderDirection]
        ) {
          return true
        }
      }
      return false
    })

    return key < 0 ? 0 : key
  }, [query, sortItems])

  const onClick = useCallback(
    (_: number, key: string, direction: string) => {
      if (key) {
        // если есть другие ключи сортировки, то исключаем их
        const excludeKeys = keys.filter((k) => k !== key)

        router.push(
          stringifyUrl(router.asPath, {
            exclude: excludeKeys,
            include: {
              [EDataKeys.orderBy]: key,
              [EDataKeys.orderDirection]: direction,
            },
          }),
          undefined,
          {
            shallow: true,
          }
        )
      } else {
        // сбрасываем ключи сортировки - удаляем из урла любой возможный ключ, поэтому передаем весь массив целиком
        router.push(
          stringifyUrl(router.asPath, {
            exclude: ['orderBy', 'orderDirection'],
          }),
          undefined,
          {
            shallow: true,
          }
        )
      }
    },
    [query, keys]
  )

  return {
    activeIndex,
    onClick,
  }
}
